import { Component, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzCheckboxGroupComponent } from "ng-zorro-antd/checkbox";

export interface NzCheckBoxOptionInterface {
  label: string;
  value: string;
  checked?: boolean;
  disabled?: boolean;
}

@Component({
  selector: "ui-checkbox-group",
  exportAs: "uiCheckboxGroup",
  templateUrl: "checkbox-group.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiCheckboxGroupComponent),
      multi: true,
    },
  ],
})
export class UiCheckboxGroupComponent extends NzCheckboxGroupComponent {
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
}
